import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import type { ComponentType } from 'react'
import Router, { useRouter } from 'next/router'
import styles from './carrierList.module.scss'
import { NavBar, SearchBar, InfiniteScroll, DotLoading } from 'antd-mobile'
import useXState from '@/src/utils/useXState'
import utils from '@/src/utils'
import IconSvg from '../IconSvg'
import jsCookie from 'js-cookie'

// 用到的词条
// ResGCountry
// ResGCompYQInput
// ResUnimPTrack
// ResGExpressGroup

interface Props {
  title: string,
  onClickCarrier?: any,
  showAuto?: boolean,
  autoClick?: any,
  $t: any,
  beforClose?: any,
  show?: boolean
}

export const CarrierListI18nEnum = ['ResGCountry', 'ResGCompYQInput', 'ResUnimPTrack', 'ResGExpressGroup', 'ResUnimPCarrierList', 'ResUnimPCarrierSelect']

const CarrierList: ComponentType<Props> = (props: Props) => {
  const router = useRouter()
  const { query, locale } = router
  const { $t } = props
  const [carrierList, setCarrierList]:[any, any] = useState([])
  const [page, setPage] = useState(0)
  const [state, updateState] = useXState({
    visible: false,
    historyList: [],
    inputVal: '',
    // carrierList: React.$carrier?.carrierList || [],
    showList: [],
    hasMore: false,
    // page: 0,
    pageSize: 20
  })
  const ResGCountryDict = $t('ResGCountry').items.itemsDict
  const onBack = () => {
    props.beforClose && props.beforClose()
    Router.back()
  }

  const onSearch = utils.func.debounce((str: string) => {
    const val = str.trim()
    const result = val ? React.$carrier.searchCarrier(val) : React.$carrier.carrierList
    initData(result)
  }, 200) 

  async function loadMore() {
    const pages = page + 1
    const { pageSize } = state
    const start = pages * pageSize
    const end = start + pageSize
    const newData = carrierList.slice(start, end)
    const showList = [...state.showList.concat(newData)]
    setPage(pages)
    updateState('showList', showList, () => {
      hasMoreByLength(newData.length)
    })
    
  }

  useEffect(() => {
    React.$carrier.updateCarrier($t)
    initData(React.$carrier?.carrierList || [])
  }, [])

  useEffect(() => {
    if (props.show && props.showAuto) initHistory()
  }, [props.show])

  const initHistory = () => {
    const keys = getHistory()
    const historyArr: Array<any> = []
    keys.forEach((key: number) => {
      const info = React.$carrier.getCarrier(key)
      if (info) {
        historyArr.push(info)
      }
    })
    updateState('historyList', [...historyArr])
  }

  const getHistory = (carrierKey?: any) => {
    let history = ''
    try {
      history = jsCookie.get('v5_HisExpress') || ''
    } catch (e) {
      console.log(e)
    }
    if (carrierKey) {
      history = carrierKey + '_' + history
    }
    return history
      ? Array.from(new Set(history.split("_").map(i => Number(i))))
      : []
  }

  const setHistory = (carrierKey: any) => {
    if (!carrierKey || carrierKey === '0') {
      return
    }

    let historyArr = getHistory(carrierKey)
    historyArr = historyArr.filter((value: string | number) => {
      return value != 0
    })

    const result = historyArr.slice(0, 8)

    //#ifdef H5
    //保存cookie;
    jsCookie.set('v5_HisExpress', result.join('_'), {
      expires: 365,
      path: '/',
      domain: '17track.net'
    })
  }
  
  const initData =(allList: Array<any>) => {
    setPage(0)
    const pageData = allList.slice(0, state.pageSize)
    setCarrierList(allList)
    updateState('showList', [...pageData], () => {
      hasMoreByLength(pageData.length)
    })
  }

  const hasMoreByLength = (length: number) => {
    updateState('hasMore', length >= state.pageSize)
  }

  const renderCounntry = (item: any) => {
    const keys = item._country_iso || '0'
    const countryObj: any = ResGCountryDict.get(keys)
    return <p className={styles.nameBox}>{countryObj._name}</p>
  } 

  const onClickCarrier = (item: any) => {
    if (query.carrierType) {
      // router.back()
      setHistory(item.key)
      props.onClickCarrier && props.onClickCarrier(item, query.carrierType || 'fc')
    } else {
      window.open(item._url)
    }
  }

  const showName = (item: any) => {
    return item['_name_' + locale] || item._name
  }

  const onClickAuto = () => {
    props.autoClick && props.autoClick()
  }

  const renderText = (item: any) => {
    if (item._country_iso) {
      return <>
        {renderCounntry(item)}
        <p className={styles.countryTitle}>{showName(item)}</p>
      </>
    } else {
      return <p className={styles.nameBox}>{showName(item)}</p>
    }
  }

  const showDefaultImg = (e: any) => {
    if (e.target) {
      e.target.src = '//res.17track.net/asset/carrier/logo/34x34/0.png'
    }
  }

  const renderItem = (item: any, index: number) => {
    return <div className={styles.itemBox} key={item.key} id={`CarrierListItemBox-${index}`} onClick={() => {onClickCarrier(item)}}>
    <div className={styles.imgIcon}>
    <div className={styles.img}>
      <Image src={`https://res.17track.net/asset/carrier/logo/120x120/${item.key}.png`} 
      onError={(e) => {showDefaultImg(e)}} 
      alt={item._name} layout='fill'/>
    </div>
    </div>
    <div className={styles.infoBox}>
      {renderText(item)}
    </div>
  </div>
  }

  return <div className={styles.container}>
    <div className={styles.topBox}>
      <NavBar onBack={onBack} className={styles.topHeadNav}>{props.title}</NavBar>
      <div className={styles.searchBox}>
        <SearchBar placeholder={$t('ResUnimPCarrierList.global.__search_placeholder')} 
          value={state.inputVal} 
          onChange={(val) => {updateState('inputVal', val);onSearch(val)}} onSearch={(val) => {onSearch(val)}}
          />
      </div>
    </div>
    <div className={styles.mainBox}>
      { props.showAuto && <div className={styles.autoBox} id='CarrierListAutoBox' onClick={() => {onClickAuto()}}>
        <IconSvg src='/asset/icons/autoBtn.svg' class={styles.iconBox}></IconSvg>
        <p className={styles.autoText}>{$t('ResGCompYQInput.global.__dialogCarrier_autoTitle')}</p>
      </div>}
      {/* 搜索历史 */}
      { !state.inputVal && state.historyList && state.historyList.length > 0 &&
        <div className={styles.historyBox}>
          <div className={styles.titleBox}>{$t("ResUnimPCarrierSelect.global.__history_title")}</div>
          {
            state.historyList.map((item: any, index: number) => {
              return renderItem(item, index)
            })
          }
        </div>
      }
      <div className={styles.listBox}>
        {
          state.showList && <>
          {state.historyList && state.historyList.length > 0 && <div className={styles.titleBox}>{$t('ResUnimPCarrierList.global.__title')}</div>}
          {
            state.showList.map((item: any, index: number) => {
              return renderItem(item, index)
            })
          }
          </>
        }
        <InfiniteScroll loadMore={loadMore} hasMore={state.hasMore} >
          { state.hasMore ? <DotLoading /> : <div>~ {$t('ResUnimPTrack.global.__noMoreUpdates')} ~</div>}
        </InfiniteScroll>
      </div>
    </div>
  </div>
}

export default CarrierList
